export const debug = (data) => {
  if (('' + window.location.host).indexOf('.dev') !== -1) console.log(data)
}
